import React from 'react'

import { StatusIcon } from '../../icons/Icons'

export const BackToBot = props => {
  const { classes } = props

  const handleEndLivechat = () => {
    if (props.isLoadingFiles) {
      return
    }

    const message = {
      from: {
        id: props.chatId,
      },
      type: 'text',
      isRtl: props.isRtl,
      text: 'back to bot',
    }
    props.postMessage(message)
  }

  return (
    <div className={classes.container}>
      <p className={classes.mainText}>
        Chat with: <span>{props.operatorName}</span> <StatusIcon />
      </p>
      <button className={classes.button} onClick={handleEndLivechat}>
        Back to Bot
      </button>
    </div>
  )
}
